import Cookies from 'js-cookie';
import { isString } from 'tcheck';

const logoutResponseUrlKey = 'logoutResponseUrl';

export function eidLogout() {
  // Get eid logout cookie
  const logoutURL = Cookies.get(logoutResponseUrlKey);
  const domain = '.myqsrsoft.com';
  Cookies.remove(logoutResponseUrlKey, { domain });

  if (!isString(logoutURL)) {
    return;
  }

  try {
    // Just confirm that the URL is valid
    new URL(logoutURL);
  } catch (_e) {
    // Throws if the URL is invalid
    return;
  }

  window.open(logoutURL, '_blank');
}
